import React from 'react';
import { useRouter } from 'next/router';
import { Box, Button, Text } from '@sparknz/spark-pattern-library';

export default function ProductOrderConfiguratorError() {
  const router = useRouter();
  return (
    <Box flexDirection="column" alignItems="center">
      <Text variant="subheadingM" mb="s3">
        Sorry, something went wrong while retrieving the plans.
      </Text>
      <Box
        gap="s2"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <Button variant="default" onClick={router.reload}>
          Try again
        </Button>
      </Box>
    </Box>
  );
}
